import { Component, type ErrorInfo, type ReactNode } from 'react'

interface State {
  hasError: boolean
}

export default class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Online Doctor Appointment render error', error, info)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="fatal-error" role="alert">
          <i className="bi bi-exclamation-octagon" aria-hidden="true" />
          <h1>Something went wrong</h1>
          <p>The application could not render this view.</p>
          <button className="btn btn-primary" onClick={() => window.location.assign('/')}>
            Return home
          </button>
        </div>
      )
    }

    return this.props.children
  }
}
